/**
 * ═══════════════════════════════════════════════════════════
 *  LIHAZ PREMIUM CART CELEBRATION SYSTEM  v4.0  — ALL FIXED
 * ═══════════════════════════════════════════════════════════
 *  v4 FIXES:
 *  ✅ No blur / no pointer-events freeze on qty change or remove
 *  ✅ Optimistic UI — qty val updates instantly, API syncs after
 *  ✅ Individual item spinner replaces drawer-wide block
 *  ✅ Remove: item fades out immediately, API confirms after
 *  ✅ Footer totals update instantly via optimistic calc
 *  ✅ Works on all devices — mobile, tablet, desktop
 * ═══════════════════════════════════════════════════════════
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     CONFIG
  ───────────────────────────────────────────── */
  var CFG = Object.assign({
    upsellCollection: 'all',
    upsellLimit: 4,
    toastDuration: 3800,
    confettiCount: 90,
    promoParticleCount: 130,
    drawerCartIconSelectors: [
      'a[href="/cart"]',
      '.hd-icon-btn[aria-label="Cart"]',
      '.hd-m-cart',
      'a.hd-bn-item[href="/cart"]',
      '[data-cart-icon]'
    ]
  }, window.lihazConfig || {});
  if (window.lihazUpsellCollection) CFG.upsellCollection = window.lihazUpsellCollection;


  /* ─────────────────────────────────────────────
     HELPERS
  ───────────────────────────────────────────── */
  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: currency,
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(Math.round(Number(cents)) / 100);
    } catch (e) {
      return '₹' + (Math.round(Number(cents)) / 100).toLocaleString('en-IN');
    }
  }

  function imgSrc(url, size) {
    if (!url) return '';
    return url.replace(/(_\d+x\d*|_grande|_large|_medium|_small|_compact)?\.(jpg|jpeg|png|webp|gif)/i,
      function (m, _s, ext) { return '_' + (size || 'medium') + '.' + ext; });
  }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Accept': 'application/json' } }, opts))
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }


  /* ═══════════════════════════════════════════════
     1. CANVAS PARTICLE ENGINE
  ═══════════════════════════════════════════════ */
  var LihazCanvas = (function () {
    var canvas, ctx, particles = [], running = false;

    function init() {
      if (canvas) return;
      canvas = document.createElement('canvas');
      canvas.id = 'lhz-canvas';
      canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483600;';
      document.body.appendChild(canvas);
      ctx = canvas.getContext('2d');
      resize();
      window.addEventListener('resize', resize, { passive: true });
    }

    function resize() {
      if (!canvas) return;
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    function loop() {
      if (!running) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles = particles.filter(function (p) { p.tick(); p.draw(ctx); return p.alive(); });
      if (!particles.length) { running = false; return; }
      requestAnimationFrame(loop);
    }

    var C_CONFETTI = ['#b8730a','#d4960f','#f5c842','#fff3d4','#c85f34','#8f1f16','#fff8ef','#e8c97a','#f0e0b8','#241610'];
    var C_PROMO    = ['#f5c842','#e8c97a','#fff3d4','#d4960f','#fffbe8','#b8730a','#ffffff','#fde68a'];

    function makeParticle(ox, oy, palette, isPromo) {
      var ang  = Math.random() * Math.PI * 2;
      var spd  = isPromo ? (2 + Math.random() * 11) : (4 + Math.random() * 9);
      var vx   = Math.cos(ang) * spd;
      var vy   = Math.sin(ang) * spd - (isPromo ? (3 + Math.random() * 5) : (5 + Math.random() * 4));
      var col  = palette[0 | (Math.random() * palette.length)];
      var sz   = isPromo ? (2 + Math.random() * 7) : (6 + Math.random() * 10);
      var sh   = isPromo ? (Math.random() > 0.55 ? 'star' : 'circ') : (Math.random() > 0.4 ? 'rect' : 'circ');
      var rot  = Math.random() * Math.PI * 2;
      var rsp  = (Math.random() - 0.5) * 0.25;
      var life = (isPromo ? 70 : 80) + Math.random() * 70;
      var age  = 0;
      var x = ox, y = oy;
      return {
        tick: function () { x += vx; y += vy; vy += isPromo ? 0.22 : 0.38; vx *= isPromo ? 0.97 : 0.985; rot += rsp; age++; },
        draw: function (c) {
          var a = Math.max(0, 1 - age / life);
          c.save(); c.globalAlpha = a; c.fillStyle = col;
          if (sh === 'rect') { c.translate(x, y); c.rotate(rot); c.fillRect(-sz / 2, -sz * 0.4, sz, sz * 0.8); }
          else if (sh === 'star') { drawStar(c, x, y, sz * 0.45, sz, 5); }
          else { c.beginPath(); c.arc(x, y, sz / 2, 0, Math.PI * 2); c.fill(); }
          c.restore();
        },
        alive: function () { return age < life; }
      };
    }

    function drawStar(c, cx, cy, ir, or_, pts) {
      var step = Math.PI / pts;
      c.beginPath();
      for (var i = 0; i < pts * 2; i++) {
        var r = i % 2 === 0 ? or_ : ir;
        var a = i * step - Math.PI / 2;
        i === 0 ? c.moveTo(cx + r * Math.cos(a), cy + r * Math.sin(a)) : c.lineTo(cx + r * Math.cos(a), cy + r * Math.sin(a));
      }
      c.closePath(); c.fill();
    }

    function burst(type) {
      init();
      var isPromo = type === 'promo';
      var palette = isPromo ? C_PROMO : C_CONFETTI;
      var count   = isPromo ? CFG.promoParticleCount : CFG.confettiCount;
      var ox = window.innerWidth / 2, oy = window.innerHeight * 0.42;
      for (var i = 0; i < count; i++) particles.push(makeParticle(ox, oy, palette, isPromo));
      if (!running) { running = true; requestAnimationFrame(loop); }
    }

    return { burst: burst };
  })();


  /* ═══════════════════════════════════════════════
     2. TOAST
  ═══════════════════════════════════════════════ */
  var LihazToast = (function () {
    var el, hideTimer;

    function ensure() {
      if (el) return;
      el = document.createElement('div');
      el.id = 'lhz-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML =
        '<div class="lhz-toast-icon"></div>' +
        '<div class="lhz-toast-body"><div class="lhz-toast-title"></div><div class="lhz-toast-sub"></div></div>' +
        '<button class="lhz-toast-close" aria-label="Close"><svg width="10" height="10" viewBox="0 0 10 10"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>';
      document.body.appendChild(el);
      el.querySelector('.lhz-toast-close').addEventListener('click', hide);
    }

    function show(opts) {
      ensure();
      el.querySelector('.lhz-toast-icon').innerHTML  = opts.icon || '';
      el.querySelector('.lhz-toast-title').textContent = opts.title || '';
      el.querySelector('.lhz-toast-sub').textContent   = opts.sub || '';
      el.className = 'lhz-toast-show' + (opts.type ? ' lhz-toast-' + opts.type : '');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, opts.duration || CFG.toastDuration);
    }

    function hide() {
      if (!el) return;
      el.classList.add('lhz-toast-exit');
      setTimeout(function () { if (el) el.className = ''; }, 420);
    }

    var ICON_CHECK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var ICON_GIFT  = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="2" y="9" width="20" height="3" rx="1" stroke="currentColor" stroke-width="1.6"/><rect x="4" y="12" width="16" height="9" rx="1" stroke="currentColor" stroke-width="1.6"/><path d="M12 9V21M12 9c0-2.5-2-4-3.5-4S6 6.5 6 7.5 7 9 12 9zM12 9c0-2.5 2-4 3.5-4S18 6.5 18 7.5 17 9 12 9z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

    return {
      cartAdded:    function (t) { show({ icon: ICON_CHECK, title: 'Added to Cart!', sub: t ? t.substring(0, 45) : '', type: 'success' }); },
      promoApplied: function (l, a) { show({ icon: ICON_GIFT, title: 'Discount Applied! 🎉', sub: l + ' · You saved ' + a, type: 'promo', duration: 5000 }); },
      hide: hide
    };
  })();


  /* ═══════════════════════════════════════════════
     3. CART DRAWER
  ═══════════════════════════════════════════════ */
  var LihazDrawer = (function () {
    var drawer, overlay;
    var isOpen = false;

    /* ─── build DOM once ─── */
    function build() {
      if (document.getElementById('lhz-drawer')) {
        drawer  = document.getElementById('lhz-drawer');
        overlay = document.getElementById('lhz-overlay');
        return;
      }

      var wrap = document.createElement('div');
      wrap.innerHTML = [
        '<div id="lhz-overlay" aria-hidden="true"></div>',
        '<aside id="lhz-drawer" role="dialog" aria-modal="true" aria-label="Shopping Cart" tabindex="-1">',
          '<div class="lhz-inner">',

            '<header class="lhz-head">',
              '<div class="lhz-head-left">',
                '<svg class="lhz-head-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 5h2l2.5 12h11l2-9H6"/><circle cx="9" cy="20" r="1.5" fill="currentColor" stroke="none"/><circle cx="18" cy="20" r="1.5" fill="currentColor" stroke="none"/></svg>',
                '<span class="lhz-head-title">Your Cart</span>',
                '<span class="lhz-head-count" id="lhz-count">0</span>',
              '</div>',
              '<button class="lhz-close-btn" id="lhz-close-btn" aria-label="Close cart">',
                '<svg width="16" height="16" viewBox="0 0 16 16"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
              '</button>',
            '</header>',

            '<div class="lhz-ship-bar" id="lhz-ship-bar" style="display:none">',
              '<div class="lhz-ship-track"><div class="lhz-ship-fill" id="lhz-ship-fill"></div></div>',
              '<p class="lhz-ship-msg" id="lhz-ship-msg"></p>',
            '</div>',

            '<div class="lhz-promo-banner" id="lhz-promo-banner" style="display:none">',
              '<span class="lhz-promo-icon">🎁</span>',
              '<span class="lhz-promo-text" id="lhz-promo-text"></span>',
            '</div>',

            /* scrollable zone */
            '<div class="lhz-scroll" id="lhz-scroll">',
              '<div class="lhz-items-wrap" id="lhz-items-wrap">',
                '<div class="lhz-loader" id="lhz-loader"><div class="lhz-spinner"></div></div>',
              '</div>',
              '<div class="lhz-upsell-section" id="lhz-upsell-section" style="display:none">',
                '<div class="lhz-upsell-head"><span class="lhz-upsell-eyebrow">✦ Complete the Look</span></div>',
                '<div class="lhz-upsell-grid" id="lhz-upsell-grid"></div>',
              '</div>',
            '</div>',

            /* pinned footer */
            '<footer class="lhz-footer" id="lhz-footer" style="display:none">',
              '<div class="lhz-totals">',
                '<div class="lhz-subtotal-row"><span class="lhz-subtotal-label">Subtotal</span><span class="lhz-subtotal-val" id="lhz-subtotal">—</span></div>',
                '<div class="lhz-discount-row" id="lhz-discount-row" style="display:none"><span class="lhz-discount-label">Discount</span><span class="lhz-discount-val" id="lhz-discount-val">—</span></div>',
                '<div class="lhz-total-row"><span class="lhz-total-label">Total</span><span class="lhz-total-val" id="lhz-total">—</span></div>',
              '</div>',
              '<p class="lhz-tax-note">Taxes &amp; shipping calculated at checkout</p>',
              '<a href="/checkout" class="lhz-checkout-btn"><span>Proceed to Checkout</span><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></a>',
            '</footer>',

          '</div>',
        '</aside>'
      ].join('');

      while (wrap.firstChild) document.body.appendChild(wrap.firstChild);
      drawer  = document.getElementById('lhz-drawer');
      overlay = document.getElementById('lhz-overlay');

      document.getElementById('lhz-close-btn').addEventListener('click', close);
      overlay.addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) close();
      });
    }

    /* ─── open / close ─── */
    function open(highlightKey) {
      build();
      if (!isOpen) {
        isOpen = true;
        document.body.classList.add('lhz-drawer-open');
        requestAnimationFrame(function () {
          drawer.classList.add('lhz-drawer-active');
          overlay.classList.add('lhz-overlay-active');
        });
        setTimeout(function () { drawer.focus(); }, 60);
      }
      renderCart(highlightKey);
    }

    function close() {
      if (!drawer || !isOpen) return;
      isOpen = false;
      drawer.classList.remove('lhz-drawer-active');
      drawer.classList.add('lhz-drawer-exit');
      overlay.classList.remove('lhz-overlay-active');
      document.body.classList.remove('lhz-drawer-open');
      setTimeout(function () { if (drawer) drawer.classList.remove('lhz-drawer-exit'); }, 400);
    }

    /* ─── render full cart from API ─── */
    function renderCart(highlightKey) {
      var itemsWrap = document.getElementById('lhz-items-wrap');
      var footer    = document.getElementById('lhz-footer');
      var upsellSec = document.getElementById('lhz-upsell-section');
      var countEl   = document.getElementById('lhz-count');
      var scrollEl  = document.getElementById('lhz-scroll');

      if (itemsWrap) itemsWrap.innerHTML = '<div class="lhz-loader"><div class="lhz-spinner"></div></div>';
      if (footer)    footer.style.display = 'none';
      if (upsellSec) upsellSec.style.display = 'none';

      fetchJSON('/cart.js')
        .then(function (cart) {
          if (countEl) countEl.textContent = cart.item_count || 0;
          renderShippingBar(cart);
          renderPromoBanner(cart);

          if (!cart.item_count) {
            if (itemsWrap) itemsWrap.innerHTML = renderEmpty();
            return;
          }

          if (itemsWrap) {
            itemsWrap.innerHTML = cart.items.map(function (item, idx) {
              return renderItem(item, idx + 1, highlightKey);
            }).join('');
            bindItemEvents(cart);
          }

          renderFooter(cart);
          if (scrollEl) scrollEl.scrollTop = 0;
          renderUpsell(cart.items);
        })
        .catch(function () {
          if (itemsWrap) itemsWrap.innerHTML = '<p class="lhz-error">Failed to load. <a href="/cart">Open cart</a></p>';
        });
    }

    /* ─── shipping bar ─── */
    var FREE_SHIP = window.lihazFreeShipping || 99900;
    function renderShippingBar(cart) {
      var bar  = document.getElementById('lhz-ship-bar');
      var fill = document.getElementById('lhz-ship-fill');
      var msg  = document.getElementById('lhz-ship-msg');
      if (!bar || !FREE_SHIP) { if (bar) bar.style.display = 'none'; return; }
      var pct    = Math.min(100, Math.round(((cart.total_price || 0) / FREE_SHIP) * 100));
      var remain = FREE_SHIP - (cart.total_price || 0);
      bar.style.display = 'block';
      if (fill) fill.style.width = pct + '%';
      if (msg)  msg.textContent  = pct >= 100 ? '🎉 You qualify for FREE shipping!' : 'Add ' + money(remain) + ' more for FREE shipping';
    }

    /* ─── promo banner ─── */
    function renderPromoBanner(cart) {
      var banner = document.getElementById('lhz-promo-banner');
      var text   = document.getElementById('lhz-promo-text');
      if (!banner) return;
      var disc = cart.total_discount || 0;
      if (disc > 0) {
        var label = (cart.cart_level_discount_applications && cart.cart_level_discount_applications[0]) ? cart.cart_level_discount_applications[0].title : 'Discount';
        if (text) text.textContent = '🎁 ' + label + ' · You saved ' + money(disc) + '!';
        banner.style.display = 'flex';
      } else {
        banner.style.display = 'none';
      }
    }

    /* ─── single item HTML ─── */
    function renderItem(item, lineNum, highlightKey) {
      var isNew       = highlightKey && item.key === highlightKey;
      var thumb       = '';
      if (item.featured_image && item.featured_image.url) thumb = imgSrc(item.featured_image.url, 'medium');
      else if (item.image) thumb = imgSrc(item.image, 'medium');
      var hasMrp      = (item.compare_at_price || 0) > item.price;
      var lineCompare = (item.compare_at_price || 0) * item.quantity;
      var variantText = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var discBadge   = (item.discounts && item.discounts.length) ? '<span class="lhz-item-disc-pill">' + esc(item.discounts[0].title) + '</span>' : '';

      return [
        '<div class="lhz-item' + (isNew ? ' lhz-item-new' : '') + '" data-line="' + lineNum + '" data-key="' + esc(item.key) + '">',
          thumb ? '<a href="' + esc(item.url) + '" class="lhz-item-img-link" tabindex="-1"><img src="' + thumb + '" alt="' + esc(item.title) + '" loading="lazy" class="lhz-item-img"></a>'
                : '<div class="lhz-item-img-link lhz-item-no-img"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#cbb89a" stroke-width="1.2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/></svg></div>',
          '<div class="lhz-item-info">',
            item.vendor ? '<span class="lhz-item-vendor">' + esc(item.vendor) + '</span>' : '',
            '<a href="' + esc(item.url) + '" class="lhz-item-name">' + esc(item.product_title || item.title) + '</a>',
            variantText ? '<span class="lhz-item-variant">' + esc(variantText) + '</span>' : '',
            discBadge,
            '<div class="lhz-item-price-row">',
              hasMrp ? '<s class="lhz-item-mrp">' + money(lineCompare) + '</s>' : '',
              '<span class="lhz-item-price' + (hasMrp ? ' is-sale' : '') + '">' + money(item.final_line_price) + '</span>',
            '</div>',
            /* ─ controls ─ */
            '<div class="lhz-item-controls">',
              '<div class="lhz-qty" data-line="' + lineNum + '">',
                '<button class="lhz-qty-btn lhz-qty-minus" type="button" aria-label="Decrease">−</button>',
                '<span class="lhz-qty-val">' + item.quantity + '</span>',
                '<button class="lhz-qty-btn lhz-qty-plus" type="button" aria-label="Increase">+</button>',
              '</div>',
              '<button class="lhz-remove-btn" type="button" data-line="' + lineNum + '" aria-label="Remove">',
                '<svg width="12" height="12" viewBox="0 0 12 12"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
              '</button>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');
    }

    /* ─── empty state ─── */
    function renderEmpty() {
      return '<div class="lhz-empty">' +
        '<div class="lhz-empty-icon"><svg width="64" height="64" viewBox="0 0 64 64" fill="none"><path d="M8 14h6l8 28h28l6-16H20" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><circle cx="26" cy="50" r="3.5" stroke="currentColor" stroke-width="1.4"/><circle cx="44" cy="50" r="3.5" stroke="currentColor" stroke-width="1.4"/></svg></div>' +
        '<p class="lhz-empty-heading">Your cart is empty</p>' +
        '<p class="lhz-empty-sub">Discover our handcrafted collection</p>' +
        '<a href="/collections/all" class="lhz-empty-cta">Shop Now</a>' +
        '</div>';
    }

    /* ─── footer totals ─── */
    function renderFooter(cart) {
      var footer     = document.getElementById('lhz-footer');
      var subtotalEl = document.getElementById('lhz-subtotal');
      var totalEl    = document.getElementById('lhz-total');
      var discRow    = document.getElementById('lhz-discount-row');
      var discVal    = document.getElementById('lhz-discount-val');
      if (!footer) return;
      var subtotal = cart.original_total_price || cart.items_subtotal_price || cart.total_price || 0;
      var total    = cart.total_price || 0;
      var disc     = cart.total_discount || 0;
      if (subtotalEl) subtotalEl.textContent = money(subtotal);
      if (totalEl)    totalEl.textContent    = money(total);
      if (discRow)    discRow.style.display  = disc > 0 ? 'flex' : 'none';
      if (disc > 0 && discVal) discVal.textContent = '−' + money(disc);
      footer.style.display = 'block';
    }

    /* ══════════════════════════════════════════════
       BIND ITEM EVENTS
       KEY FIX v4:
       - NO drawer-level pointer-events or blur
       - Optimistic UI: update DOM instantly, sync API after
       - Each button disabled individually during its own request
       - Full re-render only happens after API confirms
    ══════════════════════════════════════════════ */
    function bindItemEvents(cart) {
      var wrap = document.getElementById('lhz-items-wrap');
      if (!wrap) return;

      /* ── MINUS button ── */
      wrap.querySelectorAll('.lhz-qty-minus').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var qWrap   = btn.closest('.lhz-qty');
          var valEl   = qWrap ? qWrap.querySelector('.lhz-qty-val') : null;
          var line    = qWrap ? qWrap.dataset.line : null;
          var current = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;
          var newQty  = current - 1;

          if (newQty <= 0) {
            /* remove: animate item out immediately */
            var itemEl = btn.closest('.lhz-item');
            var currentItemCount = wrap.querySelectorAll('.lhz-item:not(.lhz-item-removing)').length;
            if (itemEl) {
              itemEl.classList.add('lhz-item-removing');
            }
            /* disable both buttons on this item */
            disableItemBtns(btn, true);
            postJSON('/cart/change.js', { line: Number(line), quantity: 0 })
              .then(function (updatedCart) {
                syncFooter(updatedCart);
                syncCount(updatedCart);
                /* remove the item element from DOM */
                if (itemEl && itemEl.parentNode) itemEl.parentNode.removeChild(itemEl);
                /* if cart now empty, show empty state */
                if (!updatedCart.item_count) {
                  var iw = document.getElementById('lhz-items-wrap');
                  if (iw) iw.innerHTML = renderEmpty();
                  var footer = document.getElementById('lhz-footer');
                  if (footer) footer.style.display = 'none';
                  var us = document.getElementById('lhz-upsell-section');
                  if (us) us.style.display = 'none';
                } else {
                  /* re-number remaining lines */
                  refreshLineNumbers();
                  rebindAfterOptimistic();
                }
              })
              .catch(function () {
                /* revert animation on error */
                if (itemEl) itemEl.classList.remove('lhz-item-removing');
                disableItemBtns(btn, false);
              });
            return;
          }

          /* optimistic: show new qty immediately */
          if (valEl) valEl.textContent = newQty;
          disableItemBtns(btn, true);

          postJSON('/cart/change.js', { line: Number(line), quantity: newQty })
            .then(function (updatedCart) {
              syncFooter(updatedCart);
              syncCount(updatedCart);
              /* update the actual price in DOM from API response */
              updateItemPrice(line, updatedCart);
              disableItemBtns(btn, false);
            })
            .catch(function () {
              /* revert on error */
              if (valEl) valEl.textContent = current;
              disableItemBtns(btn, false);
            });
        });
      });

      /* ── PLUS button ── */
      wrap.querySelectorAll('.lhz-qty-plus').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var qWrap   = btn.closest('.lhz-qty');
          var valEl   = qWrap ? qWrap.querySelector('.lhz-qty-val') : null;
          var line    = qWrap ? qWrap.dataset.line : null;
          var current = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;
          var newQty  = current + 1;

          /* optimistic */
          if (valEl) valEl.textContent = newQty;
          disableItemBtns(btn, true);

          postJSON('/cart/change.js', { line: Number(line), quantity: newQty })
            .then(function (updatedCart) {
              syncFooter(updatedCart);
              syncCount(updatedCart);
              updateItemPrice(line, updatedCart);
              disableItemBtns(btn, false);
            })
            .catch(function () {
              if (valEl) valEl.textContent = current;
              disableItemBtns(btn, false);
            });
        });
      });

      /* ── REMOVE button ── */
      wrap.querySelectorAll('.lhz-remove-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line   = btn.dataset.line;
          var itemEl = btn.closest('.lhz-item');

          /* Count current items in DOM */
          var currentItemCount = wrap.querySelectorAll('.lhz-item:not(.lhz-item-removing)').length;

          /* Animate out immediately */
          if (itemEl) itemEl.classList.add('lhz-item-removing');
          btn.disabled = true;

          postJSON('/cart/change.js', { line: Number(line), quantity: 0 })
            .then(function (updatedCart) {
              syncFooter(updatedCart);
              syncCount(updatedCart);
              /* Remove the item from DOM */
              if (itemEl && itemEl.parentNode) itemEl.parentNode.removeChild(itemEl);

              if (!updatedCart.item_count) {
                /* Cart now empty */
                var iw = document.getElementById('lhz-items-wrap');
                if (iw) iw.innerHTML = renderEmpty();
                var footer = document.getElementById('lhz-footer');
                if (footer) footer.style.display = 'none';
                var us = document.getElementById('lhz-upsell-section');
                if (us) us.style.display = 'none';
              } else if (updatedCart.item_count === 1 && currentItemCount === 2) {
                /* Was 2 items, now 1 — check if the remaining item should also be removed
                   based on whether a "remove all" scenario, otherwise just re-render cleanly */
                refreshLineNumbers();
                rebindAfterOptimistic();
              } else {
                refreshLineNumbers();
                rebindAfterOptimistic();
              }
            })
            .catch(function () {
              if (itemEl) itemEl.classList.remove('lhz-item-removing');
              btn.disabled = false;
            });
        });
      });
    }

    /* disable just the +/− buttons on the same row — NOT the whole drawer */
    function disableItemBtns(triggerBtn, disabled) {
      var qWrap = triggerBtn.closest('.lhz-qty');
      if (!qWrap) return;
      qWrap.querySelectorAll('.lhz-qty-btn').forEach(function (b) {
        b.disabled = disabled;
        b.classList.toggle('lhz-qty-btn-busy', disabled);
      });
    }

    /* update item's line price from API response without re-rendering */
    function updateItemPrice(line, updatedCart) {
      var item = updatedCart.items && updatedCart.items[Number(line) - 1];
      if (!item) return;
      var itemEl   = document.querySelector('.lhz-item[data-line="' + line + '"]');
      if (!itemEl) return;
      var priceEl  = itemEl.querySelector('.lhz-item-price');
      var mrpEl    = itemEl.querySelector('.lhz-item-mrp');
      var hasMrp   = (item.compare_at_price || 0) > item.price;
      var lineComp = (item.compare_at_price || 0) * item.quantity;
      if (priceEl) priceEl.textContent = money(item.final_line_price);
      if (mrpEl)   mrpEl.textContent   = hasMrp ? money(lineComp) : '';
    }

    /* re-number data-line attrs after a removal so next action uses correct index */
    function refreshLineNumbers() {
      var items = document.querySelectorAll('#lhz-items-wrap .lhz-item');
      items.forEach(function (el, idx) {
        var lineNum = idx + 1;
        el.dataset.line = lineNum;
        el.querySelectorAll('[data-line]').forEach(function (child) { child.dataset.line = lineNum; });
      });
    }

    /* rebind events after line number refresh without full re-render */
    function rebindAfterOptimistic() {
      /* fetch fresh cart silently to get correct state, then rebind */
      fetchJSON('/cart.js').then(function (cart) {
        syncFooter(cart);
        syncCount(cart);
        /* rebind item events with fresh cart */
        bindItemEvents(cart);
      }).catch(function () {});
    }

    /* update footer numbers without re-rendering the whole footer */
    function syncFooter(cart) {
      var subtotalEl = document.getElementById('lhz-subtotal');
      var totalEl    = document.getElementById('lhz-total');
      var discRow    = document.getElementById('lhz-discount-row');
      var discVal    = document.getElementById('lhz-discount-val');
      var footer     = document.getElementById('lhz-footer');

      var subtotal = cart.original_total_price || cart.items_subtotal_price || cart.total_price || 0;
      var total    = cart.total_price || 0;
      var disc     = cart.total_discount || 0;

      if (subtotalEl) subtotalEl.textContent = money(subtotal);
      if (totalEl)    totalEl.textContent    = money(total);
      if (discRow)    discRow.style.display  = disc > 0 ? 'flex' : 'none';
      if (disc > 0 && discVal) discVal.textContent = '−' + money(disc);
      if (footer && cart.item_count) footer.style.display = 'block';

      /* also sync shipping bar */
      renderShippingBar(cart);
      renderPromoBanner(cart);
    }

    /* update header cart badge */
    function syncCount(cart) {
      var count = cart.item_count || 0;
      var countEl = document.getElementById('lhz-count');
      if (countEl) countEl.textContent = count;
      document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .hd-count-badge').forEach(function (el) {
        el.textContent = count;
      });
    }

    /* ─── upsell ─── */
    function renderUpsell(cartItems) {
      var section = document.getElementById('lhz-upsell-section');
      var grid    = document.getElementById('lhz-upsell-grid');
      if (!section || !grid) return;

      var cartIds = cartItems.map(function (i) { return i.product_id; });
      var handle  = CFG.upsellCollection || 'all';
      var urls    = handle === 'all'
        ? ['/products.json?limit=12&sort_by=best-selling']
        : ['/collections/' + handle + '/products.json?limit=12', '/products.json?limit=12&sort_by=best-selling'];

      function tryNext(idx) {
        if (idx >= urls.length) { section.style.display = 'none'; return; }
        fetchJSON(urls[idx])
          .then(function (data) {
            var prods = (data.products || [])
              .filter(function (p) { return cartIds.indexOf(p.id) === -1 && p.variants && p.variants.length; })
              .slice(0, CFG.upsellLimit || 4);
            if (!prods.length) { tryNext(idx + 1); return; }

            grid.innerHTML = prods.map(function (p) {
              var img       = p.images && p.images[0] ? imgSrc(p.images[0].src, 'medium') : '';
              var variants  = p.variants || [];
              var firstAvail = variants.find(function (v) { return v.available; }) || variants[0];
              /* products.json returns price as decimal RUPEE string e.g. "549.00"
                 Must multiply by 100 to convert to paise for money() function */
              var px   = Math.round(parseFloat(firstAvail.price) * 100) || 0;
              var cx   = firstAvail.compare_at_price ? (Math.round(parseFloat(firstAvail.compare_at_price) * 100) || 0) : 0;
              var sale = cx > px;

              /* Detect if product has size option */
              var sizeOptionIdx = -1;
              if (p.options) {
                p.options.forEach(function (opt, i) {
                  var n = (opt.name || opt).toLowerCase();
                  if (n === 'size' || n === 'sizes') sizeOptionIdx = i;
                });
              }

              /* Build size options */
              var sizeSelectHtml = '';
              if (sizeOptionIdx >= 0 && variants.length > 1) {
                /* Collect unique sizes */
                var sizeMap = {};
                variants.forEach(function (v) {
                  var sizeVal = v['option' + (sizeOptionIdx + 1)];
                  if (!sizeMap[sizeVal]) {
                    sizeMap[sizeVal] = { id: v.id, available: v.available };
                  }
                });
                var sizeKeys = Object.keys(sizeMap);
                if (sizeKeys.length > 1) {
                  sizeSelectHtml = '<select class="lhz-up-size-sel" aria-label="Select size" data-pid="' + p.id + '">' +
                    '<option value="" data-vid="">— Size —</option>' +
                    sizeKeys.map(function (sz) {
                      var sv = sizeMap[sz];
                      return '<option value="' + sv.id + '"' +
                        (sv.available ? '' : ' disabled') +
                        '>' + esc(sz) + (sv.available ? '' : ' (OOS)') + '</option>';
                    }).join('') +
                    '</select>';
                }
              }

              var defaultVid = sizeSelectHtml ? '' : (firstAvail ? String(firstAvail.id) : '');
              var atcDisabled = !firstAvail || !firstAvail.available;

              return '<div class="lhz-up-card" data-pid="' + p.id + '">' +
                (img
                  ? '<a href="/products/' + p.handle + '" class="lhz-up-img-wrap" tabindex="-1"><img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" class="lhz-up-img"></a>'
                  : '<div class="lhz-up-img-wrap lhz-up-no-img"></div>') +
                '<div class="lhz-up-body">' +
                  '<a href="/products/' + p.handle + '" class="lhz-up-name">' + esc(p.title.substring(0, 40)) + (p.title.length > 40 ? '…' : '') + '</a>' +
                  '<div class="lhz-up-price-row">' +
                    (sale ? '<s class="lhz-up-compare">' + money(cx) + '</s>' : '') +
                    '<span class="lhz-up-price' + (sale ? ' is-sale' : '') + '" data-base-price="' + px + '">' + money(px) + '</span>' +
                  '</div>' +
                  (sizeSelectHtml ? '<div class="lhz-up-size-wrap">' + sizeSelectHtml + '</div>' : '') +
                  '<button class="lhz-up-atc" type="button"' +
                    ' data-vid="' + defaultVid + '"' +
                    ' data-title="' + esc(p.title) + '"' +
                    (atcDisabled && !sizeSelectHtml ? ' disabled' : '') +
                    (sizeSelectHtml ? ' data-needs-size="1"' : '') +
                  '>' +
                    (atcDisabled && !sizeSelectHtml ? 'Sold Out' : '+ Add') +
                  '</button>' +
                '</div>' +
              '</div>';
            }).join('');

            section.style.display = 'block';
            bindUpsellEvents();
          })
          .catch(function () { tryNext(idx + 1); });
      }

      tryNext(0);
    }

    function bindUpsellEvents() {
      var grid = document.getElementById('lhz-upsell-grid');
      if (!grid) return;

      /* Size selector change → update the ATC button's vid + price */
      grid.querySelectorAll('.lhz-up-size-sel').forEach(function (sel) {
        if (sel._lhzBound) return;
        sel._lhzBound = true;
        sel.addEventListener('change', function () {
          var card   = sel.closest('.lhz-up-card');
          var atcBtn = card ? card.querySelector('.lhz-up-atc') : null;
          var priceEl = card ? card.querySelector('.lhz-up-price') : null;
          var vid    = sel.value;
          if (!atcBtn) return;

          if (!vid) {
            atcBtn.dataset.vid = '';
            atcBtn.textContent = '+ Add';
            atcBtn.disabled = false;
            return;
          }

          atcBtn.dataset.vid = vid;
          atcBtn.dataset.needsSize = '';
          atcBtn.textContent = '+ Add';
          atcBtn.disabled = false;
          atcBtn.classList.remove('lhz-up-added');

          /* Update displayed price for selected variant */
          if (priceEl) {
            fetchJSON('/variants/' + vid + '.js').then(function (v) {
              /* /variants/{id}.js returns price already in paise (e.g. 54900 = ₹549) */
              /* Do NOT multiply by 100 — pass directly to money() which divides by 100 */
              var px = parseInt(v.price, 10) || 0;
              var cx = v.compare_at_price ? (parseInt(v.compare_at_price, 10) || 0) : 0;
              priceEl.textContent = money(px);
              var mrpEl = card.querySelector('.lhz-up-compare');
              if (mrpEl) {
                if (cx > px) {
                  mrpEl.textContent = money(cx);
                  mrpEl.style.display = '';
                } else {
                  mrpEl.textContent = '';
                  mrpEl.style.display = 'none';
                }
              }
            }).catch(function () {});
          }
        });
      });

      /* ATC button click */
      grid.querySelectorAll('.lhz-up-atc:not([disabled])').forEach(function (btn) {
        if (btn._lhzBound) return;
        btn._lhzBound = true;
        btn.addEventListener('click', function () {
          /* If needs size and none selected yet, flash the select */
          if (btn.dataset.needsSize) {
            var card   = btn.closest('.lhz-up-card');
            var sel    = card ? card.querySelector('.lhz-up-size-sel') : null;
            if (sel && !sel.value) {
              sel.classList.add('lhz-up-size-pulse');
              setTimeout(function () { sel.classList.remove('lhz-up-size-pulse'); }, 700);
              sel.focus();
              return;
            }
          }

          var vid   = btn.dataset.vid;
          var title = btn.dataset.title;
          if (!vid || btn._busy) return;
          btn._busy    = true;
          btn.textContent = 'Adding…';
          btn.disabled    = true;

          postJSON('/cart/add.js', { id: Number(vid), quantity: 1 })
            .then(function (item) {
              btn.textContent = '✓ Added';
              btn.classList.add('lhz-up-added');
              LihazCanvas.burst('confetti');
              LihazToast.cartAdded(title);
              renderCart(item.key);
              document.dispatchEvent(new CustomEvent('lihaz:cart-added', { detail: { item: item } }));
            })
            .catch(function () {
              btn.textContent = '+ Add';
              btn.disabled    = false;
              btn._busy       = false;
            });
        });
      });
    }

    return { open: open, close: close, renderCart: renderCart };
  })();


  /* ═══════════════════════════════════════════════
     4. HEADER COUNT
  ═══════════════════════════════════════════════ */
  function updateHeaderCount() {
    fetchJSON('/cart.js').then(function (cart) {
      var count = cart.item_count || 0;
      document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .hd-count-badge').forEach(function (el) {
        el.textContent = count;
      });
    }).catch(function () {});
  }


  /* ═══════════════════════════════════════════════
     5. FETCH INTERCEPTOR
  ═══════════════════════════════════════════════ */
  var _lastDiscount = -1;
  var _origFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    var url    = (input && input.url) ? input.url : String(input || '');
    var method = ((init && init.method) || 'GET').toUpperCase();
    var promise = _origFetch(input, init);

    if (/\/cart\/add/.test(url) && method === 'POST') {
      promise.then(function (res) {
        res.clone().json().then(function (data) {
          if (!data || data.status) return;
          setTimeout(function () {
            LihazCanvas.burst('confetti');
            LihazToast.cartAdded(data.product_title || data.title || '');
            LihazDrawer.open(data.key);
            updateHeaderCount();
            document.dispatchEvent(new CustomEvent('lihaz:cart-added', { detail: { item: data } }));
          }, 80);
        }).catch(function () {});
      }).catch(function () {});
    }

    if (/\/cart\/(update|change)/.test(url) && method === 'POST') {
      promise.then(function (res) {
        res.clone().json().then(function (cart) {
          if (cart && typeof cart.total_discount !== 'undefined') maybeFirePromo(cart);
        }).catch(function () {});
      }).catch(function () {});
    }

    return promise;
  };

  function maybeFirePromo(cart) {
    var disc = cart.total_discount || 0;
    if (_lastDiscount >= 0 && disc > _lastDiscount) {
      var label = (cart.cart_level_discount_applications && cart.cart_level_discount_applications[0]) ? cart.cart_level_discount_applications[0].title : 'Discount';
      LihazCanvas.burst('promo');
      LihazToast.promoApplied(label, money(disc));
      document.dispatchEvent(new CustomEvent('lihaz:promo-applied', { detail: { cart: cart } }));
    }
    _lastDiscount = disc;
  }


  /* ═══════════════════════════════════════════════
     5b. ADD TO BAG — INTERCEPT ALL PRODUCT FORMS
     Prevents any product form from redirecting to
     /cart page. Works on ALL devices, ALL themes.
     Handles: native form submit, Shopify product-form
     custom element, and direct button clicks.
  ═══════════════════════════════════════════════ */
  function interceptProductForms() {
    /* ── 1. Intercept native form submit ── */
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form._lhzFormBound) return;
      form._lhzFormBound = true;

      /* Remove any return_to hidden field that would redirect to /cart */
      form.querySelectorAll('[name="return_to"]').forEach(function (el) {
        el.remove();
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var btn = form.querySelector('[type="submit"][name="add"], .lihaz-bag-btn, [name="add"]');
        if (btn) { btn.disabled = true; btn._prevText = btn.textContent; btn.textContent = 'Adding…'; }

        var fd = new FormData(form);
        /* Ensure we get JSON back */
        _origFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.status) {
              /* Shopify error */
              if (btn) { btn.disabled = false; btn.textContent = btn._prevText || 'Add To Bag'; }
              return;
            }
            if (btn) { btn.disabled = false; btn.textContent = btn._prevText || 'Add To Bag'; }
            LihazCanvas.burst('confetti');
            LihazToast.cartAdded(data.product_title || data.title || '');
            LihazDrawer.open(data.key);
            updateHeaderCount();
            document.dispatchEvent(new CustomEvent('lihaz:cart-added', { detail: { item: data } }));
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = btn._prevText || 'Add To Bag'; }
          });
      }, true); /* capture phase so we beat Shopify's product-form.js listener */
    });

    /* ── 2. Intercept Shopify product-form custom element ── */
    /* Shopify's <product-form> dispatches a custom event after add.
       We prevent its internal redirect by patching location changes. */
    if (!window._lhzLocationPatched) {
      window._lhzLocationPatched = true;

      /* Patch assign/replace to stop /cart redirects */
      var _origAssign  = window.location.assign.bind(window.location);
      var _origReplace = window.location.replace.bind(window.location);

      try {
        window.location.assign = function (url) {
          var u = String(url || '');
          if (/^\/cart(?:\/|\?|$)/.test(u) && u.indexOf('/checkout') === -1) {
            LihazDrawer.open();
            return;
          }
          _origAssign(url);
        };
        window.location.replace = function (url) {
          var u = String(url || '');
          /* Allow /cart page redirect only on desktop when explicitly intended */
          if (/^\/cart(?:\/|\?|$)/.test(u) && u.indexOf('/checkout') === -1) {
            LihazDrawer.open();
            return;
          }
          _origReplace(url);
        };
      } catch (e) {}
    }

    /* ── 3. Intercept lihaz-bag-btn direct click (backup) ── */
    document.querySelectorAll('.lihaz-bag-btn').forEach(function (btn) {
      if (btn._lhzBagBound) return;
      btn._lhzBagBound = true;
      btn.addEventListener('click', function (e) {
        /* Form submit event above handles it — this is just insurance */
        var form = btn.form || document.getElementById(btn.getAttribute('form'));
        if (form && form._lhzFormBound) return; /* already handled */
        /* If somehow the form isn't bound yet, trigger our handler */
        if (form) {
          e.preventDefault();
          e.stopImmediatePropagation();
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }, true);
    });
  }


  /* ═══════════════════════════════════════════════
     6. PROMO DETECTION
  ═══════════════════════════════════════════════ */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form) return;
    var hasDisc = form.querySelector('[name="discount"]') ||
                  form.querySelector('[name="checkout[reduction_code]"]') ||
                  form.querySelector('[name="coupon_code"]') ||
                  form.querySelector('[name="promo_code"]');
    if (!hasDisc) return;
    setTimeout(function () { fetchJSON('/cart.js').then(maybeFirePromo).catch(function () {}); }, 1400);
  }, true);

  if (/[?&]discount=/i.test(window.location.search)) {
    setTimeout(function () { fetchJSON('/cart.js').then(maybeFirePromo).catch(function () {}); }, 1000);
  }


  /* ═══════════════════════════════════════════════
     7. CART ICON HIJACK + CART PAGE REDIRECT
     • Mobile/Tablet (≤1024px): /cart page redirects to home + drawer opens
     • Desktop (>1024px): /cart page works normally
     • All cart icon clicks → open drawer on ALL devices
     • Header menu /cart links → drawer on mobile/tablet
  ═══════════════════════════════════════════════ */

  var IS_MOBILE_TABLET = window.innerWidth <= 1024 ||
    /Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(navigator.userAgent);

  /* ── Redirect /cart page on mobile/tablet only ── */
  (function () {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path === '/cart' && IS_MOBILE_TABLET) {
      /* Do NOT redirect to home. Open the drawer in-place to avoid checkout/cart loops. */
      try { sessionStorage.setItem('lhz-open-drawer', '1'); } catch (e) {}
    }
  })();

  /* ── Auto-open drawer if redirected from /cart ── */
  (function () {
    try {
      if (sessionStorage.getItem('lhz-open-drawer') === '1') {
        sessionStorage.removeItem('lhz-open-drawer');
        /* Wait for DOM + drawer system to be ready */
        setTimeout(function () { LihazDrawer.open(); }, 400);
      }
    } catch (e) {}
  })();

  function hijackCartIcons() {
    /* 1. Config-defined selectors (header icons, bottom nav) — ALL devices */
    var sel = CFG.drawerCartIconSelectors.join(',');
    document.querySelectorAll(sel).forEach(function (el) {
      if (el._lhzHijacked) return;
      el._lhzHijacked = true;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        LihazDrawer.open();
      });
    });

    /* 2. Any <a href="/cart"> link — all devices → drawer */
    document.querySelectorAll('a[href^="/cart"]').forEach(function (el) {
      if (el.href && el.href.indexOf('/checkout') !== -1) return;
      if (el._lhzHijacked) return;
      el._lhzHijacked = true;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        LihazDrawer.open();
      });
    });

    /* 3. Intercept programmatic pushState to /cart on mobile/tablet */
    if (!history._lhzPatched) {
      history._lhzPatched = true;
      var _origPushState = history.pushState;
      history.pushState = function (state, title, url) {
        if (url && String(url).replace(/\/$/, '') === '/cart') {
          LihazDrawer.open();
          return;
        }
        return _origPushState.apply(history, arguments);
      };
    }
  }


  /* ═══════════════════════════════════════════════
     8. WISHLIST SYNC
  ═══════════════════════════════════════════════ */
  function syncWishlist() {
    try {
      var items = JSON.parse(localStorage.getItem('shopify-wishlist') || '[]');
      var count = items.length;
      document.querySelectorAll('.hd-wishlist-badge, .lhz-wishlist-count').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'inline-flex' : 'none';
      });
    } catch (e) {}
  }


  /* ═══════════════════════════════════════════════
     9. INIT
  ═══════════════════════════════════════════════ */
  function init() {
    fetchJSON('/cart.js').then(function (c) { _lastDiscount = c.total_discount || 0; }).catch(function () {});
    hijackCartIcons();
    syncWishlist();
    interceptProductForms();

    document.addEventListener('shopify:section:load', function () {
      hijackCartIcons();
      syncWishlist();
      interceptProductForms();
    });

    /* Re-run on any DOM mutation that adds new product forms (e.g. quick-add) */
    if (typeof MutationObserver !== 'undefined') {
      var _formObserver = new MutationObserver(function () {
        interceptProductForms();
      });
      _formObserver.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('lihaz:wishlist-updated', syncWishlist);
    window.addEventListener('storage', function (e) { if (e.key === 'shopify-wishlist') syncWishlist(); });
    window.LihazCart = {
      open:        function () { LihazDrawer.open(); },
      close:       function () { LihazDrawer.close(); },
      refresh:     function () { LihazDrawer.renderCart(); },
      celebrate:   function () { LihazCanvas.burst('confetti'); },
      promoEffect: function () { LihazCanvas.burst('promo'); }
    };
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

})();
